import { render } from "./Index.vue?vue&type=template&id=ffb002a0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=ffb002a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ffb002a0"

export default script